import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/hooks/useAppStore';
import { pushEvent } from '@/hooks/useAnalytics';
import { GENERATION_ACTION_LOGO_URL } from '@/config/brand';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAppStore();
  const { t } = useTranslation();

  const isHome = location.pathname === '/';
  const isProfile = location.pathname === '/profile';

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex justify-center bg-white/95 backdrop-blur-xl"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
        borderTop: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <div className="w-full max-w-md">
        <div className="flex h-14 items-center justify-around">
          {/* 首页 */}
          <button
            data-testid="nav-home"
            aria-label="nav-home"
            onClick={() => { pushEvent('nav_home_click', user?.userId); navigate('/'); }}
            className="flex flex-col items-center justify-center gap-0.5 flex-1 cursor-pointer whitespace-nowrap"
          >
            <div className={`w-5 h-5 flex items-center justify-center transition-all ${isHome ? 'text-purple-600' : 'text-gray-400'}`}>
              {isHome ? <i className="ri-home-fill text-lg" /> : <i className="ri-home-line text-lg" />}
            </div>
            <span className={`text-[10px] font-medium transition-all ${isHome ? 'text-purple-600' : 'text-gray-400'}`}>{t('nav_home')}</span>
          </button>

          {/* 生成按钮（居中主按钮）*/}
          <button
            data-testid="nav-generate"
            aria-label="nav-generate"
            onClick={() => {
              pushEvent('nav_generate_click', user?.userId, { hasUser: !!user });
              if (!user) { navigate('/login?redirect=/generate'); } else { navigate('/generate'); }
            }}
            className="flex flex-col items-center justify-center -mt-5 mx-1 cursor-pointer whitespace-nowrap"
          >
            <div
              className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden"
              style={{ boxShadow: '0 4px 16px rgba(147,51,234,0.35)' }}
            >
              <img src={GENERATION_ACTION_LOGO_URL} alt="generate" className="w-12 h-12 object-cover rounded-full" />
            </div>
          </button>

          {/* 我的 */}
          <button
            data-testid="nav-profile"
            aria-label="nav-profile"
            onClick={() => { pushEvent('nav_profile_click', user?.userId); navigate('/profile'); }}
            className="flex flex-col items-center justify-center gap-0.5 flex-1 cursor-pointer whitespace-nowrap"
          >
            <div className={`w-5 h-5 flex items-center justify-center transition-all ${isProfile ? 'text-purple-600' : 'text-gray-400'}`}>
              {isProfile ? <i className="ri-user-fill text-lg" /> : <i className="ri-user-line text-lg" />}
            </div>
            <span className={`text-[10px] font-medium transition-all ${isProfile ? 'text-purple-600' : 'text-gray-400'}`}>{t('nav_profile')}</span>
          </button>
        </div>
      </div>
    </nav>
  );
}
